import { Mail, Phone, MapPin } from "lucide-react";
import { useState, useEffect } from "react";
import { motion,AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

export default function SecOff({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Security Office | Bandarban University",
}) {
	const filtered = [
	  
	  
	];
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-600 to-teal-500 text-white py-16 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Security Office</h1>
          <p className="text-lg opacity-90">
            Guiding the future with vision, leadership, and integrity.
          </p>
        </div>
      </section>

      {/* VC Profile Section */}
       <section className="max-w-5xl mx-auto py-12 px-6 grid md:grid-cols-3 gap-8">
		
      </section>
     
		<section className="max-w-7xl mx-auto py-12 px-6 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
			{filtered.map((faculty, i) => (
			  <motion.div
				key={faculty.id}
				initial={{ opacity: 0, scale: 0.95 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{ delay: i * 0.05 }}
				className="bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden"
			  >
				<img
				  src={`${import.meta.env.VITE_API_SOURCE_URL}${faculty.image}`}
				  alt={faculty.name}
				  className="w-full h-56 object-cover"
				/>
				<div className="p-5 flex-1 flex flex-col">
					<div className="space-y-2 flex-1">
					  <h3 className="text-xl font-semibold">{faculty.name}</h3>
					  <p className="text-gray-600">{faculty.designation_name}</p>
					  <p className="text-sm text-indigo-600 font-medium">
						{faculty.department_name}
					  </p>
					  <p className="text-sm text-gray-500">📞 {faculty.mobile_number}</p>
					  <p className="text-sm text-gray-500">✉️ {faculty.email}</p>
					</div>					
				</div>
			  </motion.div>
			))}
		</section>
      {/* Vision & Mission */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Vision</h3>
            <p>To become a leading institution of higher learning in Asia.</p>
          </div>
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Mission</h3>
            <p>To nurture creativity, research, and leadership through quality education.</p>
          </div>
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Goals</h3>
            <p>Expanding research opportunities and strengthening global partnerships.</p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="bg-gradient-to-r from-teal-600 to-green-600 text-white py-12">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-4">
          <h3 className="text-2xl font-bold mb-4">Security Office</h3>
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <div className="flex items-center gap-2">
              <MapPin size={20} /> <span>K.B Road, Shualok, Post Office: Shualok - 4600, Bandarban Sadar, Bangladesh</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={20} /> <span>+880 1318-305900</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={20} /> <span>admission@bubban.ac.bd</span>
            </div>
          </div>
          <button className="mt-6 px-6 py-3 bg-white text-teal-700 font-semibold rounded-lg shadow hover:bg-gray-100">
            Request Appointment
          </button>
        </div>
      </section>
    </div>
  );
}
